/**
 * Identificação de Pagamento — o passo 2 do ato de pagar, para um LOTE de títulos.
 *
 * Substitui o "Registrar Recebimento" no menu e na rota. O nome novo não é só rótulo: a tela
 * deixou de registrar recebimento (isso é o passo 1, na tela de Pagamentos) e passou a IDENTIFICAR
 * um pagamento que já entrou. Manter o nome antigo faria duas entradas do menu prometerem a mesma
 * coisa, e a errada é a que o usuário aprendeu a usar.
 *
 * É uma casca: as três etapas vivem em `RegisterPaymentPage`, parametrizada pelo modo. As etapas 2
 * e 3 são idênticas nos dois atos — duplicá-las faria uma correção feita aqui continuar errada lá.
 * Voltar ao fluxo único é trocar a rota, não reescrever a tela.
 */
import RegisterPaymentPage from './RegisterPaymentPage';

const PaymentIdentificationPage = () => <RegisterPaymentPage mode="IDENTIFY" />;

export default PaymentIdentificationPage;
